import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-image-upload-preview',
    templateUrl: './image-upload-preview.component.html',
    styleUrls: ['./image-upload-preview.component.scss'],
    standalone: false
})
export class ImageUploadPreviewComponent {
  imageUrl: string | ArrayBuffer | null = null;
  @Input() noImgInfo: string;
  @Output() emitFile = new EventEmitter();

  onImageUpload(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.emitFile.emit(file);
      const reader = new FileReader();
      reader.onload = e => {
        this.imageUrl = e.target?.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(): void {
    this.imageUrl = null;
    this.emitFile.emit(null);
    // Optionally emit an event to inform the parent component that the image has been removed
  }
}
